module.exports = __webpack_public_path__ + "static/media/21ECLAC30.e234b274.jpg";